import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams } from 'ionic-angular';
  /**
 * Generated class for the AccountSummaryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-account-summary',
  templateUrl: 'account-summary.html',
})
export class AccountSummaryPage {
  arrAccountSummary:any=[]
  arrAccountTransDetails:any=[];
  loanstatus:boolean=true;
  emipemiamount:any;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public events:Events) {

  }
  ionSelected($events) {
  //console.log(this.navParams)
    //console.log("Home Page has been selected",$events);
   
  }
  toggleDetails(data) {
    if (data.showDetails) {
      data.showDetails = false;
      data.icon = 'ios-add-circle-outline';
    } else {
      data.showDetails = true;
      data.icon = 'ios-remove-circle-outline';
    }
  }
   
  ionViewDidLoad() {
 //    console.log("Home Page has been selected home",this.navParams.data[1].repaymentDetails
 // .responseParameters[0].emipemiamount);
    //console.log(this.navParams.data,"hello");
    this.emipemiamount =this.navParams.data[1]? this.navParams.data[1].repaymentDetails
.responseParameters[this.navParams.data[1].repaymentDetails
.responseParameters.length-1].emipemiamount:"0"
    //console.log('ionViewDidLoad AccountSummaryPage');
    this.events.subscribe('tabsEventData:created', (res:any, time) => {
      this.arrAccountSummary=res.loanParameterDetail.responseParameters;
       
       
      if(res.loanParameterDetail.responseParameters[0].loanstatus!='Active')
      {
        this.loanstatus=false;
      }
      
      
       
    })

    this.events.subscribe('tabsEventDataArrResponceEmiPEmi:created', (ress:any, time) => {
       
      //console.log(ress,"this.ar");
       this.emipemiamount=ress.repaymentDetails.responseParameters[ress.repaymentDetails
.responseParameters.length-1].emipemiamount;
       
       
      
      //console.log("getting account summary data",res.loanParameterDetail.responseParameters);
    })

    
    this.events.subscribe('TrancheAndBankDetails:created', (res:any, time) => {
      if(res.trancheDisbursementDetails.Status== "SUCCESS"){
        this.arrAccountTransDetails=res.trancheDisbursementDetails.responseParameters;
        this.arrAccountTransDetails.forEach(data => {
          data.showDetails = false;
          data.icon = 'ios-add-circle-outline';
        });
        //console.log("getting TrancheAndBankDetails data",this.arrAccountTransDetails);
      }else{
        this.arrAccountTransDetails=[]
      }
       
      
    })
    
    
    
    
  }
  numberFormatter(x) {
    //console.log(x)
    x = x.toString();
    var afterPoint = '';
    if (x.indexOf('.') > 0)
        afterPoint = x.substring(x.indexOf('.'), x.length);
    x = Math.floor(x);
    x = x.toString();
    var lastThree = x.substring(x.length - 3);
    var otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers != '')
        lastThree = ',' + lastThree;
    var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
    return res;
}
   

}



// WEBPACK FOOTER //
// ./src/pages/account-summary/account-summary.ts